<ng-container *ngIf="gatewayCommissioningStore.selectedDevice$ | async as selectedDevice">
  <div class="stepper-wrapper">
    <mat-horizontal-stepper #stepper [selectedIndex]="currentStep">
      <mat-step #first_step [completed]="true">
        <ng-template matStepLabel>{{
          '+GATEWAY_COMMISSIONING_REDESIGN.SELECT_TYPE_STEP' | translate
        }}</ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
      </mat-step>

      <mat-step #second_step>
        <ng-template matStepLabel>{{
          '+GATEWAY_COMMISSIONING_REDESIGN.STEPPER_1' | translate
        }}</ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
      </mat-step>

      <mat-step #third_step *ngIf="selectedDevice === deviceType.VITOCONNECT">
        <ng-template matStepLabel>{{
          '+GATEWAY_COMMISSIONING_REDESIGN.STEPPER_2' | translate
        }}</ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
      </mat-step>

      <mat-step #fourth_step>
        <ng-template matStepLabel>{{
          '+GATEWAY_COMMISSIONING_REDESIGN.STEPPER_3' | translate
        }}</ng-template>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
      </mat-step>
    </mat-horizontal-stepper>
  </div>

  <ng-container [ngSwitch]="activeStep">
    <ng-container *ngSwitchCase="step.INSTRUCTIONS">
      <div class="commissioning-title" data-at-gateway-commissioning-title>
        {{ '+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_CONNECTION.TITLE' | translate }}
      </div>

      <app-vitoconnect-instructions
        *ngIf="selectedDevice === deviceType.VITOCONNECT"
        (nextStep)="nextStep(stepper)"
        (previousStep)="initialStep(stepper)"
      ></app-vitoconnect-instructions>

      <app-one-base-instructions
        *ngIf="selectedDevice === deviceType.ONE_BASE"
        (nextStep)="nextStep(stepper)"
        (previousStep)="initialStep(stepper)"
      ></app-one-base-instructions>
    </ng-container>

    <ng-container *ngSwitchCase="step.CHECK_LIGHT">
      <div class="commissioning-title" data-at-gateway-commissioning-title>
        {{ '+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_VALIDATION.TITLE' | translate }}
      </div>

      <app-check-light
        (nextStep)="nextStep(stepper)"
        (previousStep)="previousStep(stepper)"
      ></app-check-light>
    </ng-container>

    <ng-container *ngSwitchCase="step.PROVIDE_TRANSFER_DATA">
      <div class="commissioning-title" data-at-gateway-commissioning-title>
        {{ '+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_TRANSFER_INSTALLATION.TITLE' | translate }}
      </div>

      <app-transfer-installation
        (previousStep)="previousStep(stepper)"
        [selectedDevice]="selectedDevice"
      ></app-transfer-installation>
    </ng-container>

    <app-transfer-success *ngSwitchDefault [activeStep]="activeStep" (reset)="initialStep(stepper)">
    </app-transfer-success>
  </ng-container>
</ng-container>
